module.exports = __webpack_public_path__ + "static/media/relaxtrans.6e2afcae.png";